import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, Building2, ClipboardCheck, Package2, PanelsTopLeft, PhoneCall, Truck } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const advantages = [
  { icon: Building2, label: "Jaringan Mitra" },
  { icon: PhoneCall, label: "Dukungan Tim Sales" },
  { icon: Truck, label: "Pengiriman Nasional" },
  { icon: ClipboardCheck, label: "Respons Kebutuhan Proyek" },
  { icon: PanelsTopLeft, label: "Portofolio Aplikasi" },
  { icon: Package2, label: "Pasokan Multi Produk" },
];

const words = ["Solusi", "Material", "untuk"];

export const Hero = () => {
  const reduceMotion = useReducedMotion();

  return (
    <section id="beranda" data-testid="hero-section" className="home-cinematic-hero">
      <div className="home-cinematic-hero__ambient" aria-hidden="true" />
      <div className="home-cinematic-hero__grid" aria-hidden="true" />

      <div className="home-cinematic-hero__inner">
        <div className="home-cinematic-hero__copy">
          <motion.div
            className="home-cinematic-hero__eyebrow"
            initial={reduceMotion ? false : { opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <span />
            PT. Animax Putra Lancar
          </motion.div>

          <h1 className="home-cinematic-hero__title">
            <span className="sr-only">Solusi Material untuk Proyek &amp; Industri</span>
            <span aria-hidden="true" className="home-cinematic-hero__title-row">
              {words.map((word, index) => (
                <motion.span
                  key={word}
                  initial={reduceMotion ? false : { y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{ duration: 0.85, delay: 0.14 + index * 0.09, ease: [0.16, 1, 0.3, 1] }}
                >
                  {word}&nbsp;
                </motion.span>
              ))}
            </span>
            <span aria-hidden="true" className="home-cinematic-hero__title-row home-cinematic-hero__title-row--accent">
              <motion.span
                initial={reduceMotion ? false : { y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.9, delay: 0.42, ease: [0.16, 1, 0.3, 1] }}
              >
                Proyek &amp; Industri
              </motion.span>
            </span>
          </h1>

          <motion.p
            className="home-cinematic-hero__description"
            initial={reduceMotion ? false : { opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.62 }}
          >
            Menyediakan pilihan material dan produk pendukung untuk kebutuhan proyek, kontraktor,
            retail, display, interior, hingga industri dengan layanan responsif dan dukungan tim
            sales yang mudah dihubungi.
          </motion.p>

          <motion.div
            className="home-cinematic-hero__actions"
            initial={reduceMotion ? false : { opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.74 }}
          >
            <a href="/#produk" data-testid="hero-cta-product" className="premium-action premium-action--primary">
              <Package2 className="w-4 h-4" />
              Lihat Produk Kami
              <ArrowRight className="w-4 h-4 premium-action__arrow" />
            </a>
            <a href="/kontak#kontak" data-testid="hero-cta-quote" className="premium-action premium-action--ghost">
              Hubungi PT APL
              <ArrowRight className="w-4 h-4 premium-action__arrow" />
            </a>
          </motion.div>

          <motion.div
            className="home-cinematic-hero__facts"
            initial={reduceMotion ? false : { opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <div><strong>2021</strong><span>Berdiri Sejak</span></div>
            <div><strong>Mojokerto</strong><span>Jawa Timur</span></div>
          </motion.div>
        </div>

        <motion.div
          className="home-cinematic-hero__visual"
          data-testid="hero-visual"
          initial={reduceMotion ? false : { opacity: 0, x: 50, clipPath: "inset(0 0 100% 0)" }}
          animate={{ opacity: 1, x: 0, clipPath: "inset(0 0 0% 0)" }}
          transition={{ duration: 1.15, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="home-cinematic-hero__visual-frame cursor-parallax cursor-parallax--main">
            <img src={PHOTOS.kantorDisplay} alt="Kantor Display PT Animax Putra Lancar" loading="eager" fetchPriority="high" decoding="async" />
            <div className="home-cinematic-hero__visual-shade" />
          </div>
          <div className="home-cinematic-hero__visual-index" aria-hidden="true">APL</div>
        </motion.div>
      </div>

      <div className="home-cinematic-hero__marquee" aria-label="Keunggulan PT Animax Putra Lancar">
        <div className="home-cinematic-hero__marquee-track">
          {[...advantages, ...advantages].map((item, index) => (
            <div className="home-cinematic-hero__marquee-item" key={`${item.label}-${index}`}>
              <item.icon />
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
